<template>
  <div style="height: 100%; background: #0f3565">
    <v-img
      src="../../assets/external.svg"
      style="z-index: 2; position: absolute"
      height="100%"
    ></v-img>

    <div
      class="d-flex justify-end mt-4"
      style="position: absolute; width: 100%; z-index: 10"
    >
      <ChangeLocale />
    </div>

    <router-view />
  </div>
</template>

<style lang="scss" scoped></style>

<script>
import ChangeLocale from '../../components/ChangeLocale.vue'

export default {
  name: 'NotAuthenticated',

  components: {
    ChangeLocale,
  },
}
</script>
